import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
var _excluded = ["url", "buttonText", "buttonType", "popupText", "buttonClassName", "infoButtonClassName", "bestValueText", "accessibilityLabel", "infoAttributes"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useRef } from 'react';
import classnames from 'classnames';
import styles from "./InfoButton.module.scss";
import { Button } from "../Button/Button";
import { Popup } from "../../Popup/Popup/Popup";
import { Text } from "../../Text/Text/Text";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var InfoButton = function InfoButton(_ref) {
  var _ref$url = _ref.url,
    url = _ref$url === void 0 ? '' : _ref$url,
    _ref$buttonText = _ref.buttonText,
    buttonText = _ref$buttonText === void 0 ? '' : _ref$buttonText,
    _ref$buttonType = _ref.buttonType,
    buttonType = _ref$buttonType === void 0 ? 'secondary' : _ref$buttonType,
    _ref$popupText = _ref.popupText,
    popupText = _ref$popupText === void 0 ? '' : _ref$popupText,
    _ref$buttonClassName = _ref.buttonClassName,
    buttonClassName = _ref$buttonClassName === void 0 ? '' : _ref$buttonClassName,
    _ref$infoButtonClassN = _ref.infoButtonClassName,
    infoButtonClassName = _ref$infoButtonClassN === void 0 ? '' : _ref$infoButtonClassN,
    _ref$bestValueText = _ref.bestValueText,
    bestValueText = _ref$bestValueText === void 0 ? '' : _ref$bestValueText,
    _ref$accessibilityLab = _ref.accessibilityLabel,
    accessibilityLabel = _ref$accessibilityLab === void 0 ? '' : _ref$accessibilityLab,
    _ref$infoAttributes = _ref.infoAttributes,
    infoAttributes = _ref$infoAttributes === void 0 ? {} : _ref$infoAttributes,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var popupComponent = useRef(null);
  var togglePopup = function togglePopup() {
    var _popupComponent$curre;
    popupComponent === null || popupComponent === void 0 ? void 0 : (_popupComponent$curre = popupComponent.current) === null || _popupComponent$curre === void 0 ? void 0 : _popupComponent$curre.togglePopup();
  };
  var isBestValue = !!bestValueText;
  var bestValueIconPosition = isBestValue ? classnames(styles.bestValueIconPosition) : '';
  return /*#__PURE__*/_jsxs("div", {
    className: classnames('info-button', styles['info-button'], infoButtonClassName),
    children: [/*#__PURE__*/_jsxs("div", {
      className: classnames(styles.buttonWrapper, buttonClassName),
      children: [isBestValue && /*#__PURE__*/_jsx("div", {
        className: styles.bestValue,
        children: bestValueText
      }), /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
        type: buttonType,
        url: url,
        className: styles.secondaryText,
        size: "large"
      }, otherProps), {}, {
        children: buttonText
      }))]
    }), popupText && /*#__PURE__*/_jsx("div", {
      className: styles.iconWrapper + ' ' + bestValueIconPosition,
      children: /*#__PURE__*/_jsx(Popup, {
        ref: popupComponent,
        handle: /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
          type: "no-style",
          onClick: togglePopup,
          "aria-label": accessibilityLabel,
          "aria-haspopup": "dialog",
          accessibilityLabel: accessibilityLabel,
          className: classnames(styles.iconButton, isBestValue ? styles.extraMargin : '')
        }, infoAttributes), {}, {
          children: /*#__PURE__*/_jsx("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            "aria-hidden": "true",
            focusable: "true",
            className: styles.infoIcon,
            children: /*#__PURE__*/_jsx("path", {
              d: "M12.001 2C17.5244 2 22.0027 6.47755 22.0029 12.001C22.0029 17.5246 17.5246 22.0029 12.001 22.0029C6.47755 22.0027 2 17.5244 2 12.001C2.00021 6.47768 6.47768 2.00021 12.001 2ZM12.001 3.5C7.30611 3.50021 3.50021 7.30611 3.5 12.001C3.5 16.696 7.30598 20.5027 12.001 20.5029C16.6962 20.5029 20.5029 16.6962 20.5029 12.001C20.5027 7.30598 16.696 3.5 12.001 3.5ZM12.001 10.5205C12.415 10.5205 12.7507 10.8565 12.751 11.2705V14.6602H13.0967C13.5109 14.6602 13.8467 14.9959 13.8467 15.4102C13.8464 15.8242 13.5107 16.1602 13.0967 16.1602H12.001C11.5871 16.16 11.2512 15.824 11.251 15.4102V12.0205H10.9062C10.492 12.0205 10.1562 11.6847 10.1562 11.2705C10.1565 10.8565 10.4922 10.5205 10.9062 10.5205H12.001ZM11.1445 7.64258C11.5352 7.25302 12.1678 7.25321 12.5576 7.64355C12.9473 8.03395 12.9467 8.66656 12.5566 9.05664C12.1666 9.44672 11.5339 9.44734 11.1436 9.05762C10.7534 8.66795 10.7526 8.03521 11.1416 7.64453L11.1426 7.64355L11.1445 7.64258Z"
            })
          })
        })),
        clickOutsideDeactivates: true,
        children: /*#__PURE__*/_jsx(Text, {
          typog: "captionSmall",
          richText: true,
          children: popupText
        })
      })
    })]
  });
};